// extracted by mini-css-extract-plugin
export var auto = "_2g-1";
export var spinner = "_2g-0";